export const TEMPLATES = {
  afterTaxAnnuity: 'Template: After Tax Annuity',
  afterTaxAnnuityMoneyMarket: 'Template: After Tax Annuity Money Market',
  collectiveInvestmentTrust: 'Collective Investment Trust',
  fdicInsuredBankProduct: 'Template: FDIC Insured Bank Product',
  fixedAnnuityOther: 'Template: Other Fixed Annuity',
  fixedAnnuityTiaaQdia: 'Template: TIAA QDIA Fixed Annuity',
  fixedAnnuityTiaaTraditional: 'Template: TIAA Traditional',
  fixedAnnuityTiaaStableValue: 'Template: TIAA Stable Value',
  fixedAnnuityTiaaStableValueNonProp: 'Template: Non-Prop TIAA Stable Value',
  loading: 'Template: Loading',
  mutualFund: 'Template: Mutual Fund',
  mutualFundMoneyMarket: 'Template: Mutual Fund Money Market',
  mutualFundNonProp: 'Template: Non-Prop Mutual Fund',
  mutualFundNonPropMoneyMarket: 'Template: Non-Prop Mutual Fund Money Market ',
  none: 'Template: None',
  other: 'Template: Other Investments',
  otherMoneyMarket: 'Template: Other Investments Money Market',
  retirePlus: 'Template: RetirePlus',
  targetDate: 'Template: Target Date',
  variableAnnuityCref: 'Template: CREF Variable Annuity',
  variableAnnuityCrefMoneyMarket:
    'Template: CREF Variable Annuity Money Market',
  variableAnnuityOther: 'Template: Other Variable Annuity',
  variableAnnuityTiaaAccess: 'Template: TIAA Access',
  variableAnnuityTiaaAccessMoneyMarket: 'Template: TIAA Access Money Market',
  variableAnnuityTiaaAccessNonProp: 'Template: Non-Prop TIAA Access',
  variableAnnuityTiaaAccessNonPropMoneyMarket:
    'Template: Non-Prop TIAA Access Money Market',
  variableAnnuityTiaaRealEstate: 'Template: TIAA Variable Annuity Real Estate'
};

const templateByTemplateRawLower = {
  'after tax annuity': TEMPLATES.afterTaxAnnuity,
  'after tax annuity money market': TEMPLATES.afterTaxAnnuityMoneyMarket,
  'collective investment trust': TEMPLATES.collectiveInvestmentTrust,
  'fdic insured bank product': TEMPLATES.fdicInsuredBankProduct,
  'other fixed annuity': TEMPLATES.fixedAnnuityOther,
  'tiaa qdia fixed annuity': TEMPLATES.fixedAnnuityTiaaQdia,
  'tiaa traditional': TEMPLATES.fixedAnnuityTiaaTraditional,
  'tiaa stable value': TEMPLATES.fixedAnnuityTiaaStableValue,
  'non-prop tiaa stable value': TEMPLATES.fixedAnnuityTiaaStableValueNonProp,
  'mutual fund': TEMPLATES.mutualFund,
  'mutual fund money market': TEMPLATES.mutualFundMoneyMarket,
  'non-prop mutual fund': TEMPLATES.mutualFundNonProp,
  'non-prop mutual fund money market ': TEMPLATES.mutualFundNonPropMoneyMarket,
  none: TEMPLATES.none,
  other: TEMPLATES.other,
  'other investments': TEMPLATES.other,
  'other investments money market': TEMPLATES.otherMoneyMarket,
  retireplus: TEMPLATES.retirePlus,
  'target date': TEMPLATES.targetDate,
  'cref variable annuity': TEMPLATES.variableAnnuityCref,
  'cref variable annuity money market':
    TEMPLATES.variableAnnuityCrefMoneyMarket,
  'other variable annuity': TEMPLATES.variableAnnuityOther,
  'tiaa access': TEMPLATES.variableAnnuityTiaaAccess,
  'tiaa access money market': TEMPLATES.variableAnnuityTiaaAccessMoneyMarket,
  'non-prop tiaa access': TEMPLATES.variableAnnuityTiaaAccessNonProp,
  'non-prop tiaa access money market':
    TEMPLATES.variableAnnuityTiaaAccessNonPropMoneyMarket,
  'tiaa variable annuity real estate': TEMPLATES.variableAnnuityTiaaRealEstate
};

const getProfileTemplates = (templateRaw = '', isCit) => {
  if (isCit) return TEMPLATES.collectiveInvestmentTrust;

  return (
    templateByTemplateRawLower[templateRaw.toLowerCase()] || TEMPLATES.none
  );
};

export default getProfileTemplates;
